// src/auth/UsernameEditor.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../tattoo/lib/supabaseClient";

export default function UsernameEditor({ onSuccess }) {
  const [value, setValue] = useState("");
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data } = await supabase.from("profiles").select("username").eq("id", user.id).maybeSingle();
      if (data?.username) {
        setValue(data.username);
        setOk(true);
      }
    })();
  }, []);

  const onChange = (e) => {
    const v = e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "_").slice(0, 30);
    setValue(v);
    setError("");
    setOk(false);
  };

  const save = async () => {
    setChecking(true);
    setError("");
    try {
      if (!value || value.length < 3) {
        setError("Username must be at least 3 characters.");
        return;
      }
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      // server-side unique constraint will enforce uniqueness
      const { error: upErr } = await supabase
        .from("profiles")
        .update({ username: value })
        .eq("id", user.id);

      if (upErr) {
        // duplicate, etc
        setError(upErr.message || "Username not available.");
        return;
      }

      setOk(true);
      onSuccess?.();
    } catch (e) {
      setError(e.message || "Save failed.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div style={{ marginTop: 12 }}>
      <label style={{ display: "block", color: "#ddd", marginBottom: 8 }}>
        Username
      </label>
      <div style={{ display: "flex", gap: 8 }}>
        <input
          value={value}
          onChange={onChange}
          placeholder="shep"
          style={{
            flex: 1,
            padding: "10px 12px",
            borderRadius: 8,
            border: "1px solid #2a2a2a",
            background: "#0f0f0f",
            color: "#fff",
            outline: "none",
          }}
        />
        <button className="btn" onClick={save} disabled={checking} style={{ padding: "10px 14px", borderRadius: 8 }}>
          {checking ? "Saving…" : "Save"}
        </button>
      </div>
      {!!error && <div style={{ color: "#ff6b6b", marginTop: 8 }}>{error}</div>}
      {ok && <div style={{ color: "#7dff9e", marginTop: 8 }}>Saved! 🎉</div>}
    </div>
  );
}